import { read, utils } from 'xlsx';//for sheet.JS
import { useRef, useState, useEffect } from 'react';// for hooks and mount loading
import React from 'react';// for react
import * as XLSX from 'xlsx'

import axios from 'axios';
import 'semantic-ui-css/semantic.min.css'
import {BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom';
import { Divider } from 'semantic-ui-react';

 










const handleSubmit = async (e) => {
    e.preventDefault()//dont reload the page
    
}


function ExcelIntegration(){
    const [Name,setName] = useState('') // using hooks so they can be used in the form 
    const [tillTotal,setTillTotal] = useState(0)
    const [Entries,setEntries] = useState()//Entry Hook
    const [submit, setSubmit] = useState(false)
    const [cash, setCash] = useState(0)
    const [card, setCard] = useState(0);
    const [ramsySales, setRamsySales] = useState(0);
    const [ramsyCard, setRamsyCard] = useState(0);
    const [ramsyPt, setRamsyPt] = useState(0);
    const [boss, setBoss] = useState(0);
    const [ramsy, setRamsy] = useState(0);
    const [phone, setPhone] = useState(0);
    const [opt1name,setopt1name] = useState('')
    const [opt1, setopt1] = useState(0)
    const [opt2name,setopt2name] = useState('')
    const [opt2, setopt2] = useState(0)
    const [opt3name,setopt3name] = useState('')
    const [opt3, setopt3] = useState(0)
    const [opt4name,setopt4name] = useState('')
    const [opt4, setopt4] = useState(0)
    const [post,setPosted] = useState('');
    const [opt5name,setopt5name] = useState('')
    const [opt5, setopt5] = useState(0)
    const [diff, setDiff] = useState(0)
    const [closing,setClosing] = useState(0)
    const [currentDate,setcurrentDate] = useState('')
    const [currentDay, setcurrentDay] = useState('')





    

    
    
    function convertJSON({Name, currentDate, currentDay,tillTotal, cash, card, ramsySales, ramsyCard, ramsyPt, boss, ramsy, phone , opt1name, opt1, opt2name, opt2, opt3name, opt3, opt4name, opt4, opt5name, opt5}){//using props
        const date = new Date()//getting date and time
        let total = (parseFloat(tillTotal) + parseFloat(ramsySales)) 
        console.log(total)
        let otherTotal = (parseFloat(cash) + parseFloat(card)) + parseFloat(boss) + parseFloat(ramsy) + parseFloat(phone) + (parseFloat(opt1) + parseFloat(opt2) + parseFloat(opt3) + parseFloat(opt4) + parseFloat(opt5))
        let shop = parseFloat(tillTotal) - parseFloat(ramsyCard)
        let ramsyTotal = parseFloat(ramsyCard) + parseFloat(ramsySales)
        let proportion = ramsyPt/ramsyTotal
        let firstTotal = parseFloat(ramsySales) + parseFloat(tillTotal)
        
        let difference = otherTotal-total 
        console.log(difference)
        if (isNaN(difference) === true){
          alert("Error, Please Try Again,make sure all other values are 0")
          console.log(2)
        
        }
        setDiff(difference)



        

        const JSONobj = {
          Date: date,
          Name: Name,
          currentDate:currentDate, 
          currentDay:currentDay,
          Till_total: tillTotal,
          shop:shop,
          ramsy_total: ramsyTotal,
          proportion:proportion,
          first_total: firstTotal,
          cash: cash,
          card: card,
          ramsy_sales:ramsySales,
          ramsy_card:ramsyCard,
          ramsy_pt:ramsyPt,
          boss:boss,
          ramsy:ramsy,
          phone:phone,
          total:otherTotal,
          difference:difference//calculative
 


        }
        console.log(JSONobj)// checking the correct object is being parse
        setSubmit(!submit)//setting submit field to True
        setEntries(JSONobj)//Setting JSON to a hook so it can be used globally
        // +', "Money":'+Money


        

        
        
        
    }


    function Submit(){
        axios.post('https://sheet.best/api/sheets/a56c01ed-6130-465d-a18b-7d0f622ccd61', Entries)
        .then(response => {
          console.log(response);
          setPosted('Success!')
        })

    }

    

    return(
        <form onSubmit={handleSubmit} >
          <div className="entireForm">
            <div className="labelWrapper">
               {/* Name */}
                    <label htmlFor="Name"> Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="Name"
                      onChange={(e) => setName(e.target.value)}
                      value={Name}
                    />

                  <label htmlFor="currentDate">Current Date:</label>
                  <input
                    className="typein__box"
                    type="currentDate" 
                    id="currentDate"

                     onChange = {(e)=> setcurrentDate(e.target.value)} 
                    value = {currentDate}
                    required
                    />

             
                <label htmlFor="currentDay">Current Day:</label>
                <input
                 className="typein__box"
                 type="currentDay" 
                 id="currentDay"

                 onChange = {(e)=> setcurrentDay(e.target.value)} 
                 value = {currentDay}
                 required
                />

                    {/* tillTotal */}
                    <label htmlFor="tillTotal"> tillTotal:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="tillTotal"
                      onChange={(e) => setTillTotal(e.target.value)}
                      value={tillTotal}
                    />
                    {/* cash */}
                    <label htmlFor="cash"> cash:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="cash"
                      onChange={(e) => setCash(e.target.value)}
                      value={cash}
                    />

                    {/* card */}
                    <label htmlFor="card"> card:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="card"
                      onChange={(e) => setCard(e.target.value)}
                      value={card}
                    />
                    
                    <label htmlFor="ramsySales"> Ramsy Sales:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="ramsySales"
                      onChange={(e) => setRamsySales(e.target.value)}
                      value={ramsySales}
                    />

                    <label htmlFor="ramsyCard"> Ramsy Card:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="ramsyCard"
                      onChange={(e) => setRamsyCard(e.target.value)}
                      value={ramsyCard}
                    />

                    <label htmlFor="ramsyPt"> Ramsy Pt:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="ramsyPt"
                      onChange={(e) => setRamsyPt(e.target.value)}
                      value={ramsyPt}
                    />

                    <label htmlFor="boss"> Boss:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="boss"
                      onChange={(e) => setBoss(e.target.value)}
                      value={boss}
                    />

                    <label htmlFor="ramsy"> Ramsy:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="ramsy"
                      onChange={(e) => setRamsy(e.target.value)}
                      value={ramsy}
                    />

                    <label htmlFor="phone"> Phone:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="phone"
                      onChange={(e) => setPhone(e.target.value)}
                      value={phone}
                    />

                    
                    


                    

         
                

                


                    {/* opt1name */}
                    <label htmlFor="opt1name"> Option 1 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt1name"
                      onChange={(e) => setopt1name(e.target.value)}
                      value={opt1name}
                    />

                    {/* opt1 */}
                    <label htmlFor="opt1"> Option 1:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt1"
                      onChange={(e) => setopt1(e.target.value)}
                      value={opt1}
                    />

                    {/* opt2name */}
                    <label htmlFor="opt2name"> Option 2 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt2name"
                      onChange={(e) => setopt2name(e.target.value)}
                      value={opt2name}
                    />

                    {/* opt2 */}
                    <label htmlFor="opt2"> Option 2:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt2"
                      onChange={(e) => setopt2(e.target.value)}
                      value={opt2}
                    />

                    {/* opt3name */}
                    <label htmlFor="opt3name"> Option 3 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt3name"
                      onChange={(e) => setopt3name(e.target.value)}
                      value={opt3name}
                    />

                    {/* opt3 */}
                    <label htmlFor="opt3"> Option 3:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt3"
                      onChange={(e) => setopt3(e.target.value)}
                      value={opt3}
                    />

                    {/* opt4name */}
                    <label htmlFor="opt4name"> Option 4 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt4name"
                      onChange={(e) => setopt4name(e.target.value)}
                      value={opt4name}
                    />

                    {/* opt4 */}
                    <label htmlFor="opt4"> Option 4 :</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt4"
                      onChange={(e) => setopt4(e.target.value)}
                      value={opt4}
                    />

                    {/* opt5name */}
                    <label htmlFor="opt5name"> Option 5 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt5name"
                      onChange={(e) => setopt5name(e.target.value)}
                      value={opt5name}
                    />

                    {/* opt5 */}
                    <label htmlFor="opt5"> Option 5:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt5"
                      onChange={(e) => setopt5(e.target.value)}
                      value={opt5}
                    />

          

                </div>



                
                
                
                
                
                <div className = "buttonWrapper"><button className="button-10" onClick={() => convertJSON({Name, currentDate, currentDay,tillTotal, cash, card, ramsySales, ramsyCard, ramsyPt, boss, ramsy, phone , opt1name, opt1, opt2name, opt2, opt3name, opt3, opt4name, opt4, opt5name, opt5  
})} >Submit</button></div>
               { submit ?<div className='finalMessage'> <div className = "buttonWrapper" ><p>Difference:  £{diff.toFixed(2)}</p><Link to="/Diary"><button className ="confirmButton button-10" onClick={() => Submit(Entries)}>Confirm Submit </button></Link> <p className='green'>{post}</p></div><a href="mailto:hsugarnan2005@gmail.com">Report Error in Accounts</a></div>: <div className='buttonWrapper'><p className="smallFont">SugarTech 2023©</p></div>  }
               </div>
           
          </form>
    )


}


export default ExcelIntegration